import React, { useEffect, useState } from "react";
import "../../../Styles/Redirecting Styles/FooterStyle/MainTestimonial.css";
import "../../../Styles/Testimonial.css";
import { animateScroll as scroll } from "react-scroll";
import axios from "axios";
import CompanyTestimonial from "../../Components/seperate Components/CompanyTestimonial";
import CanadaFooter from "../../Components/Footer";
import CanadaHeader1 from "../../Components/seperate Components/CanadaHeader1";
import { Helmet } from "react-helmet";
import Pagination from "../../Components/seperate Components/Pagination";

const CanadaMainTestimonial = () => {
  const toggleContact = () => {
    scroll.scrollToTop(0, 0);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [isLoading, setLoading] = useState(true);
  const [testimonials, setTestimonials] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [postPerPage] = useState(4);
  const [video, setVideo] = useState(null);

  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const response = await axios.get("https://mars.zithas.com/api/usa_testimonial");
        const sanitizedData = response.data.map((item) => ({
          ...item,
          video: typeof item.video === "string" ? item.video : null,
        }));
        setTestimonials(sanitizedData); 
        setLoading(false);
      } catch (err) {
        console.error("Error fetching testimonials:", err);
      }
    };
    fetchTestimonials();
  }, []);

  const indexOfLastPost = currentPage * postPerPage;
  const indexOfFirstPost = indexOfLastPost - postPerPage;
  const currentPosts = testimonials.slice(indexOfFirstPost, indexOfLastPost);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <div>
      <Helmet>
        <title>Testimonials | Zithas Technologies USA</title>
        <meta
          name="description"
          content="Discover why clients love Zithas Technologies. Exceptional service, and innovative IT solutions. Read testimonials that speak to our excellence."
        />
      </Helmet>

      <CanadaHeader1 />

      {/* Banner Section */}
      <div
        className="bd-page-title-area bd-page-title-bg3 pt-220 pb-155"
        style={{ height: "380px" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div
                className="bd-page-title text-center z-index"
                style={{ bottom: "45px" }}
              >
                <h2
                  className="breadcrumb-title"
                  style={{ fontSize: "50px", color: "#4a026c" }}
                >
                  Testimonials
                </h2>
                <div className="breadcrumb-menu">
                  <nav className="breadcrumb-trail breadcrumbs">
                    <p style={{ color: "black" }}>
                      We're the professionals that have always been there for our clients. We're their personal testimonial!
                    </p>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Testimonial Section */}
      <CompanyTestimonial text={currentPosts} />

      {/* Pagination */}
      <Pagination
        postPerPage={postPerPage}
        totalPosts={testimonials.length}
        paginate={paginate}
      />

      <CanadaFooter />
    </div>
  );
};

export default CanadaMainTestimonial;
